import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import type {
	LWApiPublicAccountUserAvailableParamsRawI,
	LWApiPublicAccountUserAvailableResultRawI,
} from '@liquidweb-dev/club-sauce/public/account/user/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const ACCOUNT_USER_AVAILABLE_QUERY_KEY = '/account/user/available';

const useAccountUserAvailable = (
	params: LWApiPublicAccountUserAvailableParamsRawI,
	options?: UseQueryOptions<
		LWApiPublicAccountUserAvailableResultRawI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [ACCOUNT_USER_AVAILABLE_QUERY_KEY, params],
		queryFn: () => api.account.user.apiRaw.available(params),
		...options,
	});

export default useAccountUserAvailable;
